import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemTypesDelete: {},
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemTypesDeleteSlice = createSlice({
  name: "itemTypesDeleteSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showDeleteItemTypesDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemTypesDelete: action.payload,
      };
    },
    closeDeleteItemTypesDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showDeleteItemTypesDialog,
  closeDeleteItemTypesDialog,
  showLoading,
  hideLoading
} = itemTypesDeleteSlice.actions;

export default itemTypesDeleteSlice.reducer;
